import layout from '@/layout'

export default {
  path: '/info',
  component: layout,
  redirect: '/info/message',
  name: 'info_message',
  meta: {
    title: 'info',
    icon: 'info'
  },
  children: [
    {
      path: '/info/message',
      name: 'info_message',
      component: () => import('@/views/info/message/index'),
      meta: {
        title: 'info_message',
        icon: 'info'
      }
    }
  ]
}
